<template>
  <img src="/assets/img/pushone_logo_white_01.png" />
</template>